import { Auth } from 'aws-amplify'
import AwsConfig from '../../Config/AwsConfig'
import UpdateMovie from '../../Services/Mutations/UpdateMovie'
import { castfun } from './castfun'
import { crewfun } from './crewfun'
import { truevalueedit } from './truevalueedit'
import { toast } from 'react-toastify'
import { ToastStyle } from '../Data/MovieStaticData'

function lowerFirstLetter(string) {
  return string.charAt(0).toLowerCase() + string.slice(1)
}

function formatReleaseDate(inputDate) {
  const dateComponents = inputDate.split('-')
  return dateComponents.join('')
}

// Mapping function for truevalueedit calls
function mapAndUpdateTrueValues(dataMappings, input) {
  dataMappings.forEach(({ trueValue, inputValue, property }) => {
    truevalueedit([trueValue, inputValue], input, property)
  })
}

function checkIfAllFieldsFilled(inputData) {
  const { yousayArticleReviews } = inputData

  if (!yousayArticleReviews) {
return null
}

  // Remove __typename and fields with null values
  const { __typename, ...rest } = yousayArticleReviews
  const filteredReviews = Object.fromEntries(
    Object.entries(rest).filter(([_key, value]) => value !== null && value !== '' && value !== undefined),
  )

  // Check if the resulting object is empty
  return Object.keys(filteredReviews).length > 0 ? [filteredReviews] : null
}

const ottReleaseInt = minOttDate => {
  if (minOttDate.toString().length === 8) {
    return parseInt(minOttDate, 10)
  }

  if (minOttDate.toString().length === 6) {
    const tempReleaseDate = minOttDate + '00'
    return parseInt(tempReleaseDate, 10)
  }

  const tempReleaseDate = minOttDate + '0000'
  return parseInt(tempReleaseDate, 10)
}

const SubmitEditMovie = async (movieData, inputData, truevalue) => {
  let loggedInUserHandle = ''
  const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''

  if (loggedInUserEmail) {
    const emailParams = loggedInUserEmail.split('@')
    loggedInUserHandle = '@' + emailParams[0]
  }

  const input = Object.values(truevalue).some(e => e === true)
    ? {
        PK: movieData.PK,
        SK: movieData.SK,
        movieID: movieData.movieID,
        updateCombinations: truevalue.genre || truevalue.ageRestrict || truevalue.movierating || truevalue.ott,
        updateCast: truevalue.cast,
        updateCrew: truevalue.crew,
        zee5Link: '',
        sunNextLink: '',
        sonyLiv: '',
        primeLink: '',
        netflixLink: '',
        hotstarLink: '',
        etvApp: '',
        ahaLink: '',
        youtubeLink: '',
        mxPlayer: '',
        jioCinemaLink: '',
        contentType: inputData.contentType,
        moderatorID: Auth.user.username,
        moderatorHandle: loggedInUserHandle,
      }
    : ''
const movieInfoMappings = [
  { trueValue: truevalue.movienamete, inputValue: inputData.movieNamete, property: 'title_Te' },
  { trueValue: truevalue.Distibutor_En, inputValue: inputData.MovieDistibutor.toString(), property: 'distributedBy_En' },
  { trueValue: truevalue.Distibutor_En, inputValue: inputData.MovieDistibutorTelugu.toString(), property: 'distributedBy_Te' },
  { trueValue: truevalue.ProductionCompany_En, inputValue: inputData.MovieProductionCompany.toString(), property: 'productionCompany_En' },
  { trueValue: truevalue.ProductionCompany_En, inputValue: inputData.MovieProductionCompanyTelugu.toString(), property: 'productionCompany_Te' },
  { trueValue: truevalue.genre, inputValue: inputData.genRe, property: 'genre_En' },
  { trueValue: truevalue.Basedon_En, inputValue: inputData.based.toString(), property: 'basedOn_En' },
  { trueValue: truevalue.Basedon_En, inputValue: inputData.basedte.toString(), property: 'basedOn_Te' },
  { trueValue: truevalue.Biote, inputValue: inputData.biote, property: 'about_Te' },
  { trueValue: truevalue.poster, inputValue: inputData.poster.replace(AwsConfig.movieCdnUrl, ''), property: 'posterURL' },
  { trueValue: true, inputValue: inputData.language.map(e => e.label).toString(), property: 'language' },
  { trueValue: truevalue.country, inputValue: inputData.country, property: 'country' },
  { trueValue: truevalue.runtime, inputValue: inputData.runTime, property: 'runningTime' },
  { trueValue: truevalue.budget, inputValue: inputData.Budget, property: 'budget' },
  { trueValue: truevalue.boxOffice, inputValue: inputData.collection, property: 'boxOffice' },
  { trueValue: truevalue.Bio, inputValue: inputData.Bio, property: 'about_En' },
  { trueValue: truevalue.moviename, inputValue: inputData.movieName, property: 'title_En' },
  { trueValue: truevalue.popularMovie, inputValue: inputData.popularMovie, property: 'popularMovie' },
  { trueValue: truevalue.GOAT, inputValue: inputData.GOAT, property: 'GOAT' },
  { trueValue: truevalue.originalLanguageTelugu, inputValue: inputData.originalLanguageTelugu, property: 'originalLanguageTelugu' },
  { trueValue: true, inputValue: inputData.restrit.toString(), property: 'ageRestriction' },
  {
    trueValue: truevalue.internalComments,
    inputValue: inputData.internalComments,
    property: 'internalComments',
  },
  {
    trueValue: truevalue.sendTFIDBPN,
    inputValue: inputData.sendTFIDBPN,
    property: 'sendTFIDBPN',
  },
  {
    trueValue: inputData.sendTFIDBPN,
    inputValue: inputData.PNInfo,
    property: 'PNInfo',
  },
  // { trueValue: true, inputValue: parseInt(formatReleaseDate(inputData.releaseDate), 10), property: 'movieReleasedDate' },
  // {
  //   trueValue: truevalue.MovieYouSayReviewUrlTe,
  //   inputValue: inputData.MovieYouSayReviewUrlTe,
  //   property: 'yousayMovieReviewURL_Te',
  // },
  // {
  //   trueValue: truevalue.MovieYouSayReviewUrl,
  //   inputValue: inputData.MovieYouSayReviewUrl,
  //   property: 'yousayMovieReviewURL_En',
  // },
// {
// trueValue: true,
// inputValue: formatReleaseDate(inputData.releaseDate),
// property: 'movieReleasedDateUI',
// },
{
trueValue: true,
inputValue: inputData.wikilink,
property: 'wikipediaLink',
},
{
  trueValue: inputData.contentType === 'webseries',
  inputValue: parseInt(inputData.noOfEpisodes, 10),
  property: 'noOfEpisodes',
},
// {
//   trueValue: truevalue.movieReviewArticleTitle_En,
//   inputValue: inputData.movieReviewArticleTitleEn,
//   property: 'movieArticleReviewTitle_En',
// },
{
  trueValue: truevalue.yousayArticleReviews,
  inputValue: checkIfAllFieldsFilled(inputData),
  property: 'yousayArticleReviews',
},
]

const cast = castfun(inputData.Moviecast, inputData.castte)

  truevalueedit([true, cast], input, 'cast')

  truevalueedit([true, crewfun(inputData)], input, 'crew')
if (inputData.movieStatus.includes('MovieReleaseDateRevealed') || inputData.movieStatus.includes('MovieReleased')) {
  // const today = new Date()
  // const oneYearFromToday = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate())
  // const formattedDefaultDate = oneYearFromToday.toISOString().split('T')[0]
  // truevalueedit([true, parseInt(formatReleaseDate(formattedDefaultDate), 10)], input, 'movieReleasedDate')
  // truevalueedit([true, 'To be announced'], input, 'movieReleasedDateUI')
  truevalueedit([true, parseInt(formatReleaseDate(inputData.releaseDate), 10)], input, 'movieReleasedDate')
  truevalueedit([true, formatReleaseDate(inputData.releaseDate)], input, 'movieReleasedDateUI')
  truevalueedit([true, inputData.movieStatus], input, 'movieStatus')
} else {
  // truevalueedit([true, inputData.movieStatus], input, 'movieReleasedDate')
  truevalueedit([true, inputData.movieStatus], input, 'movieStatus')
}

if (inputData.OTTStatus.includes('OTTProviderDateAndLinkAvailable')) {
  updateOttInformation(inputData, input)
  truevalueedit([true, inputData.OTTPlatformsWithLangs.map(
    item => {
      // Create a copy of the object without the field '__typename'
      const { __typename, ...updatedItem } = item
      return updatedItem
    },
  )], input, 'OTTPlatformsWithLangs')
  truevalueedit([true, inputData.OTTStatus], input, 'OTTStatus')
} else {
  const OttData = []
  const ottDates = []

  inputData.Movielinks.forEach((e, index) => {
    const OttName = inputData.ott[index].label
    const ottStatus = inputData.OTTStatus

    if (ottStatus.includes('OTTProviderRevealedAndDateAnnounced') ||
        ottStatus.includes('OTTProviderAndDateKnownAndLinkNotAvailable')) {
      ottDates.push(e.ottDate)

      if (OttName) {
        OttData.push(OttName)
        if (OttName === 'MXPlayer') {
          truevalueedit([true, ''], input, 'mxPlayer')
        } else {
          truevalueedit([true, ''], input, OttName === 'SonyLiv' || OttName === 'EtvApp' ?
            lowerFirstLetter(OttName.toString()) :
            `${lowerFirstLetter(OttName.toString())}Link`)
        }
      }
    } else if (ottStatus.includes('OTTProviderRevealedAndLinkAvailableAndDateNotKnown')
    ) {
      if (e.link && OttName) {
        OttData.push(OttName)
        if (OttName === 'MXPlayer') {
          truevalueedit([true, e.link], input, 'mxPlayer')
        } else {
          truevalueedit([true, e.link], input, OttName === 'SonyLiv' || OttName === 'EtvApp' ?
            lowerFirstLetter(OttName.toString()) :
            `${lowerFirstLetter(OttName.toString())}Link`)
        }
      }
    } else if (ottStatus.includes('OTTProviderRevealedAndDateTBA')) {
      if (OttName) {
        OttData.push(OttName)
        if (OttName === 'MXPlayer') {
          truevalueedit([true, ''], input, 'mxPlayer')
        } else {
          truevalueedit([true, ''], input, OttName === 'SonyLiv' || OttName === 'EtvApp' ?
            lowerFirstLetter(OttName.toString()) :
            `${lowerFirstLetter(OttName.toString())}Link`)
        }
      }
    }
  })

  if (ottDates.length > 0) {
    const minOttDate = ottDates[0].toString().split('-').join('')
    input.ottReleasedDate = ottReleaseInt(minOttDate)
    input.ottReleasedDateUI = minOttDate.toString()
  }

  truevalueedit([true, OttData], input, 'ottPlatform')

    truevalueedit([true, inputData.OTTStatus], input, 'OTTStatus')

  truevalueedit([true, inputData.OTTPlatformsWithLangs.map(item => {
    // Create a copy of the object without the field '__typename'
    const { __typename, ...updatedItem } = item
    // if (OttData.includes(updatedItem.platform)) {
        return updatedItem // If the platform exists in OttData, return the original item
    // }

        // return null // If not, return null (or you can choose to return something else)
})], input, 'OTTPlatformsWithLangs')
}

  await mapAndUpdateTrueValues(movieInfoMappings, input)

  // Update movie rating separately
  updateMovieRating(inputData, input)

  // Update gallery
  updateGallery(inputData, truevalue, input)

  // Ott information
  // if (truevalue.movieAndOTTNewsUpdates) {
  //   input.movieAndOTTNewsUpdates = inputData.movieAndOTTNewsUpdates
  // }

  const update = Object.values(truevalue).some(e => e === true) ? await UpdateMovie(input) : ''
  if (update.statusCode === 'A001') {
      toast.success(update.statusMessage, ToastStyle)
  }

  return update.statusCode
}

const updateMovieRating = (inputData, input) => {
  if (inputData.imdb !== '') {
    input.movieRating = parseFloat(inputData.imdb)
    input.deleteFields = ['yousayRating']
  }

  if (inputData.MovieYouSayRating !== '') {
    input.yousayRating = parseFloat(inputData.MovieYouSayRating)
  }
}

const updateGallery = (inputData, truevalue, input) => {
  // Update Gallery Videos
  if (inputData.GalleryVideos) {
    const galleryVideos = inputData.GalleryVideos.map(e => ({
      path: e.path.replace(AwsConfig.movieCdnUrl, ''),
      title: e.title,
      thumbnail: e.thumbnail,
    }))
    input.galleryVideos = galleryVideos
  }

  // Update Gallery Images
  if (inputData.GalleryImages) {
    const galleryImages = inputData.GalleryImages.map(e => ({
      path: e.path.replace(AwsConfig.movieCdnUrl, ''),
      title: e.title,
    }))
    truevalueedit(
      [truevalue.GalleryImages, galleryImages],
      input,
      'galleryImages',
    )
    }

  // Update Gallery Images Time
  if (inputData.imageUpdatedTime) {
    truevalueedit(
      [truevalue.GalleryImages, inputData.imageUpdatedTime],
      input,
      'imageUpdatedTime',
    )
  }
}

const updateOttInformation = (inputData, input) => {
  let ottDates = []
  const OttData = []

  inputData.Movielinks.forEach((e, index) => {
    const OttName = inputData.ott[index].label
    ottDates.push(e.ottDate)
    if (e.link) {
      if (OttName) {
        OttData.push(OttName)
        if (OttName === 'MXPlayer') {
          truevalueedit([true, e.link], input, 'mxPlayer')
        } else {
          truevalueedit(
            [true, e.link],
            input,
            OttName === 'SonyLiv' || OttName === 'EtvApp'
              ? lowerFirstLetter(OttName.toString())
              : `${lowerFirstLetter(OttName.toString())}Link`,
          )
        }
      }
    }
  })

  truevalueedit([true, OttData], input, 'ottPlatform')

  const checkOttFieldsExists = inputData.Movielinks && inputData.Movielinks.length > 0
  const checkOtt = checkOttFieldsExists && inputData.Movielinks.some(e => e.link)

  ottDates = ottDates.filter(e => e)

 if (checkOtt && ottDates && ottDates.length > 0) {
    const minOttDate = ottDates[0].toString().split('-').join('')

    if (minOttDate) {
      input.ottReleasedDate = ottReleaseInt(minOttDate)
      input.ottReleasedDateUI = minOttDate.toString()
    }
  }
}

export default SubmitEditMovie
